import apiPaths from '../../api-paths';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.CRM }/crm-mails${ query }`);
  },
  indexAll(query = '') {
    return axios.get(`${ apiPaths.CRM }/crm-mails/index-all${ query }`);
  },
  markAsRead(original) {
    return axios.post(`${ apiPaths.CRM }/crm-mails/${ original }/mark-as-read`);
  }
}